import React from 'react';

import { CSSTransitionGroup } from 'react-transition-group';

import { Field } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';

import * as validator from 'helpers/Validator';
import { AccentColor } from 'helpers/AccentColorHelper';
import { RenderError } from 'components/shared/RenderError';
import MenuItem from 'material-ui/MenuItem';
import { getTranslatedString } from 'helpers/i18n';
import { AdditionalOccupantStatus } from 'components/shared/StatusHelper';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import { featureEnabled } from 'helpers/ToggleBot';
import { colors } from 'helpers/ColorHelper';

const styles = {
  addOccupantButton: {
    color: 'white',
  },
  iconButton: {
    padding: 0,
    verticalAlign: 'text-bottom',
    width: 'none',
    height: 'none',
    float: 'right',
  },
  field: { marginTop: '-15px', fontSize: '14px', width: '100%' },
};

export default ({ fields, meta, onDelete, disabled, enableAddAndRemove }) => {
  const deleteAdditionalOccupant = (index) => {
    let occupant_id = fields.get(index).id;
    if (onDelete && occupant_id) {
      onDelete(occupant_id);
    }
    fields.remove(index);
  };

  const shouldShowDeleteButton =
    (featureEnabled('ui.rent_roll_page.delete_residents') || enableAddAndRemove) && !disabled;
  const shouldShowAddButton =
    (featureEnabled('ui.rent_roll_page.add_residents') || enableAddAndRemove) && !disabled;
  return (
    <div className="row">
      <CSSTransitionGroup
        transitionName="add_occupant"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {fields.map((occupant, index) => (
          <div key={index} className="row">
            <div style={{ padding: '0 15px' }}>
              <h4 style={{ lineHeight: '26px' }}>
                {getTranslatedString('landlordPortal.occupantsFormFields.occupant')} #{index + 1}
                <AdditionalOccupantStatus occupant={fields.get(index)} />
                {shouldShowDeleteButton && (
                  <IconButton
                    style={styles.iconButton}
                    onClick={() => deleteAdditionalOccupant(index)}
                  >
                    <DeleteIcon size={24} style={{ padding: 0 }} />
                  </IconButton>
                )}
              </h4>
            </div>

            <div className="row">
              <div className="col-sm-6" style={{ marginTop: '15px' }}>
                <Field
                  name={`${occupant}.full_name`}
                  component={TextField}
                  disabled={disabled}
                  type="text"
                  label={getTranslatedString('landlordPortal.occupantsFormFields.fullName')}
                  fullWidth
                  validate={[validator.required, validator.fullName]}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className="col-sm-6" style={{ marginTop: '15px' }}>
                <Field
                  name={`${occupant}.birthday`}
                  type="date"
                  component={DatePickerAccessible}
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="top-end"
                  label={getTranslatedString('landlordPortal.occupantsFormFields.birthday')}
                  fullWidth
                  minDate={new Date('1920-01-01')}
                  maxDate={new Date()}
                  validate={[validator.required]}
                  variant="outlined"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6" style={{ marginTop: '15px' }}>
                <Field
                  name={`${occupant}.email`}
                  component={TextField}
                  disabled={disabled}
                  type="email"
                  label={getTranslatedString('landlordPortal.occupantsFormFields.email')}
                  fullWidth
                  validate={[validator.validEmail]}
                  variant="outlined"
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${occupant}.phone_number`}
                  component={ReactPhoneInput}
                  disabled={disabled}
                  label={getTranslatedString('landlordPortal.occupantsFormFields.phoneNumber')}
                  fullWidth
                  validate={[validator.required, validator.validInternationalPhoneNumber]}
                  variant="outlined"
                />
              </div>
            </div>
            <div className="row" style={{ marginBottom: '10px' }}>
              <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${occupant}.relationship`}
                  component={OutlinedSelect}
                  label={getTranslatedString('landlordPortal.occupantsFormFields.relationship')}
                  errorStyle={{ fontSize: '14px' }}
                  disabled={disabled}
                  validate={[validator.required]}
                >
                  <MenuItem value={'Significant Other'}>
                    {getTranslatedString('landlordPortal.occupantsFormFields.significantOther')}
                  </MenuItem>
                  <MenuItem value={'Child'}>
                    {getTranslatedString('landlordPortal.occupantsFormFields.child')}
                  </MenuItem>
                  <MenuItem value={'Sibling'}>
                    {getTranslatedString('landlordPortal.occupantsFormFields.sibling')}
                  </MenuItem>
                  <MenuItem value={'Cousin'}>
                    {getTranslatedString('landlordPortal.occupantsFormFields.cousin')}
                  </MenuItem>
                  <MenuItem value={'Extended Family'}>
                    {getTranslatedString('landlordPortal.occupantsFormFields.extendedFamily')}
                  </MenuItem>
                  <MenuItem value={'Friend'}>
                    {getTranslatedString('landlordPortal.occupantsFormFields.friend')}
                  </MenuItem>
                </Field>
              </div>
            </div>
          </div>
        ))}
      </CSSTransitionGroup>
      {shouldShowAddButton && (
        <div className="row" style={{ textAlign: 'center', margin: '20px 0 20px' }}>
          <FlatButton
            label={getTranslatedString('landlordPortal.otherOccupantsFieldArray.addOccupant')}
            type="button"
            backgroundColor={!disabled ? AccentColor() : colors.GRAY}
            hoverColor="grey"
            style={styles.addOccupantButton}
            onClick={() => {
              fields.push({});
            }}
            disabled={disabled}
          />

          <RenderError meta={meta} />
        </div>
      )}
    </div>
  );
};
